<template>
  <div style="min-width:270px;">

    <div class="mdc-drawer-app-content">
      <main class="main">
        <div v-if="!error" class="main-content jobs">
          <div class="jobs-header-wrapper">
            <div class="jobs-header">

              <div class="main-wrapper" style="overflow:visible; margin-top: 16px;">
                <div>
                  <app-search-detailed
                    ref="searchbar"
                    :searchFilter="company"
                    :suggestions="industries"
                    v-model="searchValue"
                    v-bind="searchOptions"
                    v-on="searchEvents"
                    @clear="onSearchClear"
                    @search="onSearchRole" />
                </div>
              </div>

            </div>
          </div>

          <div v-if="jobs" class="main-wrapper main-content-wrapper">

            <company-feature-section
              @filter="applyCompanyFilter"
              v-if="hasfeaturedCompanies"
              :isMobile="isMobile"
              :isDesktopLarge="isDesktopLarge"
              :isTabletLarge="isTabletLarge"
              :isTablet="isTablet"
              :companies="featuredCompanies"
              style="margin-bottom:6px;"/>

            <mdc-layout-grid v-if="!featureCompanyFiltered" style="padding-top:0px;padding-bottom:0px;">
              <mdc-layout-cell span="4" class="jobroles">
                <div class="location-wrapper" style="width:100%">
                  <mdc-select :dense="true" class="locationmenu" v-model="locationFilter">
                    <img slot="leadingIcon" src="/static/img/icons/location_outline_light.svg" style="width:21px;height:21px;"/>
                    <mdc-select-item value="" text="All" />
                    <mdc-select-item v-for="loc in topLocations" :key="loc" :value="loc" />
                  </mdc-select>
                </div>
              </mdc-layout-cell>
            </mdc-layout-grid>
            <mdc-layout-grid style="padding-bottom:0px;padding-top:6px;">
              <mdc-layout-cell span=12>
                <mdc-title style="flex:1;margin-bottom:0;display:flex;">
                  <span style="display:flex" v-if="jobsCount >= 1">
                    <span>Job Vacancies</span>
                    <span style="display:flex;" v-if="company"> &nbsp; - {{company}}</span>
                  </span>
                </mdc-title>
              </mdc-layout-cell>
            </mdc-layout-grid>

            <mdc-layout-grid style="padding-bottom:0px;padding-top:6px;">
              <mdc-layout-cell span=12>
                <div class="section-sub-title sub-label">
                  <mdc-body typo="body2" style="margin-top:0" v-if="jobsCount >= 1"><span class="not-mobile">Showing</span> {{jobroles.length}} of {{jobsCount}} results</mdc-body>
                  <mdc-body class="section-sub-title" style="margin-top:16px;" typo="body2" v-if="jobsCount === 0">Whoops, this search has no results, try something different.</mdc-body>
                </div>
              </mdc-layout-cell>
            </mdc-layout-grid>

            <mdc-layout-grid style="padding-top:6px;">
              <mdc-layout-cell v-for="jobrole in jobroles" :key="jobrole.id" span=4 class="jobroles">
                <a target="_blank" class="job-card-link" external :href="`${appUrl}/job-detail/${jobrole.id}`">
                  <job-role-card-mobile :likelyFlexFilter="true" hoverHigh showDesc hideShare class="mobileonly" :jobrole="jobrole"></job-role-card-mobile>
                  <job-role-card :likelyFlexFilter="true" hoverHigh hideShare showDesc class="desktoponly" :jobrole="jobrole"></job-role-card>
                </a>
              </mdc-layout-cell>
            </mdc-layout-grid>

            <mdc-layout-grid v-if="jobsCount > jobs.length" style="padding-top:6px;">
              <mdc-layout-cell span=4 class="jobroles">
                <span class="additional">
                  <span>Load </span>
                  <round-button class="inline-button" noHover hasSlot @click="loadMoreJobs">More</round-button>
                </span>
              </mdc-layout-cell>
            </mdc-layout-grid>

          </div>

        </div>
        <div v-else>
          <div class="jobs-not-found">Jobs not found</div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { headroom } from 'vue-headroom'
import AppNav from './components/AppNav'
import RoundButton from './components/RoundButton'
import JobRoleCard from './components/JobRoleCard'
import JobRoleCardMobile from './components/JobRoleCardMobile'
import AppSearchDetailed from './components/AppSearchDetailed'
import CompanyFeatureSection from './components/CompanyFeatureSection'
import { industries } from './utils/filters'
import { appUrl, publicProfilesUrl } from './settings'
const fetch = require('node-fetch')

export default {
  data () {
    return {
      windowWidth: 800,
      throttled: false,
      desktop: true,
      isMobile: false,
      isTablet: false,
      isTabletLarge: false,
      isDesktopLarge: false,
      appUrl,
      locationFilter: null,
      open: false,
      start: 0,
      jobroles: [],
      jobsCount: 0,
      searchValue: '',
      searchOptions: {},
      searchEvents: {},
      topLocations: [
        'London',
        'Manchester',
        'Bristol',
        'Leeds',
        'Birmingham',
        'Sheffield',
        'Reading',
        'Cambridge',
        'Milton Keynes',
        'Nottingham',
        'Southampton',
        'Liverpool',
        'Glasgow',
        'Oxford',
        'Northampton',
        'Edinburgh',
        'Derby',
        'Peterborough',
        'Cardiff',
        'Warrington'
      ],
      industries,
      featureCompanyFiltered: false // to hide location drop down when featured company is clicked
    }
  },
  props: {
    location: '',
    industry: '',
    role: '',
    company: '',
    error: false,
    jobsfound: 0,
    jobs: {
      type: Array,
      default: function () {
        return []
      }
    },
    featuredCompanies: {}
  },
  methods: {
    async loadMoreJobs () {
      this.start = this.start + 12
      const queryUrl = `${publicProfilesUrl}/api/jobs?start=${this.start}&location=${this.location}&industry=${this.industry}&role=${this.role}&company=${this.company}`
      console.log(queryUrl)
      const result = await fetch(queryUrl, {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      const jobsDocs = await result.json()
      const morejobs = jobsDocs.result.response.docs
      this.jobsCount += jobsDocs.result.response.numFound
      this.jobroles = [...this.jobroles, ...morejobs]
    },
    applyCompanyFilter (company) {
      console.log('JobsPage.applyCompanyFilter', company)
      window.location.pathname = `/flexible-jobs/_${company.name}_`
    },
    onSearchRole (role) {
      console.log('JobsPage.onSearchRole', this.searchValue, this.role)
      this.searchValue = `${role}`
      if (this.searchValue !== this.role) {
        window.location.pathname = `/flexible-jobs/${this.locationFilter}_${this.company}_${this.searchValue}`
      }
    },
    onSearchLocation () {
      console.log('JobsPage.onSearchLocation', this.locationFilter, this.location)
      if (this.locationFilter !== this.location) {
        window.location.pathname = `/flexible-jobs/${this.locationFilter}_${this.company}_${this.searchValue}`
      }
    },
    onSearchClear (event) {
      console.log('JobsPage.onSearchClear', event)
      window.location.pathname = `/flexible-jobs/${this.locationFilter}`
    }
  },
  components: {
    AppNav,
    headroom,
    JobRoleCard,
    JobRoleCardMobile,
    AppSearchDetailed,
    CompanyFeatureSection,
    RoundButton
  },
  computed: {
    hasfeaturedCompanies () {
      if (this.featuredCompanies) {
        return Object.keys(this.featuredCompanies).length
      }
      return false
    }
  },
  created () {
    this.windowWidth = window.innerWidth
  },
  mounted () {
    console.log('JobsPage.mounted', this.location, this.company, this.role)
    console.log('JobsPage.featuredCompanies', this.featuredCompanies)
    this.searchValue = this.role
    this.locationFilter = this.location
    this.jobroles = this.jobs
    this.jobsCount = this.jobsfound
    if (process.client) {
      window.addEventListener('resize', () => {
        if (!this.throttled) {
          this.throttled = true
          setTimeout(() => {
            this.throttled = false
            this.windowWidth = window.innerWidth
          }, 200)
        }
      })
    }
    if (this.company) {
      this.featureCompanyFiltered = true
    }
  },
  watch: {
    windowWidth: {
      handler: function (newW, oldW) {
        this.$set(this, 'desktop', this.windowWidth >= 840)
        this.$set(this, 'isMobile', this.windowWidth <= 470)
        this.$set(this, 'isTablet', this.windowWidth >= 470 && this.windowWidth <= 670)
        this.$set(this, 'isTabletLarge', this.windowWidth >= 670 && this.windowWidth <= 880)
        this.$set(this, 'isDesktopLarge', this.windowWidth >= 1240)
      },
      immediate: true
    },
    locationFilter (newl, oldl) {
      console.log(`JobsPage.watch - locationFilter ${newl}`)
    //   this.onSearchLocation()
    }
  }
}
</script>

<style>
:root {
    --mdc-theme-primary: #2d9cdb;
    --mdc-theme-on-primary: #ffffff;
    --mdc-theme-secondary: #e91e63;
}
.headroom--pinned {
  transform: translate3d(0px, 0px, 0px) !important;
}
.additional {
  color: rgba(0,0,0,.54);
  display:flex;
}
.additional .inline-button {
    margin: 0!important;
    margin-top: -1px!important;
    padding-left: 6px!important;
    text-transform: lowercase;
    font-weight: 400;
    font-size: 1em;
    line-height: 1em;
    height: 20px!important;
    padding-right: 4px!important;
    text-decoration: underline;
}
.mdc-card-content {
  padding: 16px;
}
.mdc-select .mdc-select__anchor.select-width-class {
  background-color:transparent;
  display: flex;
}

.mdc-select .mdc-select__menu {
  background-color:#F0F0F0;
}

.mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.select-width-class.mdc-menu-surface--open {
  min-width: 160px;
}

.mdc-select .mdc-select__menu .mdc-list-item {
    background-color:white;
}

@media all and (min-width: 570px) {
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.select-width-class.mdc-menu-surface--open {
    max-height: 270px !important;
  }
  .mdc-select .mdc-select__menu .mdc-list-item {
    background-color:white;
    margin:6px;
    padding:6px;
    padding-left:16px;
  }
}

.mdc-linear-progress {
  position: absolute;
  margin-top: 48px;
}
.mdc-text-field:not(.mdc-text-field--disabled):not(.mdc-text-field--outlined):not(.mdc-text-field--textarea)
  .mdc-text-field__input {
  border-bottom: none;
  margin: 6px;
  margin-bottom: 0px;
  padding: 0;
}
.mdc-text-field:not(.mdc-text-field--disabled):not(.mdc-text-field--outlined):not(.mdc-text-field--textarea)
  .mdc-text-field__input:hover {
  border-bottom: none;
  padding: 0;
}
.mdc-text-field .mdc-line-ripple {
  display: none;
}
.mdc-text-field--upgraded:not(.mdc-text-field--fullwidth):not(.mdc-text-field--box):not(.mdc-text-field--textarea):not(.mdc-text-field--outlined) {
  padding: 0;
}
.mdc-list-item__graphic {
  margin-right: 12px;
}
.mdc-layout-app .mdc-layout-app--content-wrapper {
  background-color: #fcfcfc;
}
.mdc-drawer-app-content {
  flex: auto;
  overflow: auto;
  min-height: 100vh;
  z-index: auto;
  width: 100%;
  height: auto;
  top: 0;
  max-height: 100%;
  overflow-x: hidden;
}
.mdc-top-app-bar .avatar {
  width: 42px;
  border-radius: 500px;
  -webkit-border-radius: 500px;
  -moz-border-radius: 500px;
}
.main-content {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  min-height: 800px;
}
.main-wrapper {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
  overflow: visible;
}
.main-menu-bar {
  height: 4.5rem;
  margin: 0;
}
.main-menu-bar-item {
  min-width: 100px;
  padding-right: 0;
  padding-left: 0;
  border-right: 0;
  border-left: 0;
  color: gray;
  text-transform: none;
}
.burger-bar {
  display: none;
}
.searchbar
  .mdc-text-field:not(.mdc-text-field--disabled):not(.mdc-text-field--textarea) {
  margin: 4px 0;
  height: 30px;
  padding-left: 40px;
}
.searchbar
  .mdc-text-field--with-leading-icon.mdc-text-field--dense
  .mdc-text-field__icon {
  top: 2px;
  left: 2px;
}
.mdc-text-field--with-leading-icon.mdc-text-field--dense .mdc-floating-label {
  bottom: 6px;
  color: #979797;
}
.mdc-text-field--with-leading-icon.mdc-text-field--dense
  .mdc-floating-label--float-above {
  display: none;
}
@media (max-width: 479px) {
  .main-wrapper > .mdc-layout-grid {
    padding-left: 0;
    padding-right: 0;
  }
}
@media all and (min-width: 570px) {
  .mobileonly {
    display: none !important;
  }
}
@media all and (max-width: 570px) {
  .desktoponly {
    display: none !important;
  }
  .main-wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.main-menu-bar .mdc-tab-bar__indicator {
  background-color: white;
}
.top-navbar {
  width: 100%;
}
.bottom-navbar {
  background: linear-gradient(#e91e63, #ad1457);
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
}
.indicator-online {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background-color: #00897b;
}
.indicator-online::after {
  content: "online";
  font-size: 12px;
  margin-left: 16px;
  display: inline-block;
  line-height: 10px;
  position: absolute;
}
.indicator-offline {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background-color: #979797;
}
.indicator-offline::after {
  content: "offline";
  font-size: 12px;
  margin-left: 16px;
  display: inline-block;
  line-height: 10px;
  position: absolute;
}
.indicator-away {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background-color: #ffb300;
}
.indicator-away::after {
  content: "away";
  font-size: 12px;
  margin-left: 16px;
  display: inline-block;
  line-height: 10px;
  position: absolute;
}

.right-drawer {
  position: fixed;
  right: 0;
  top: 72px;
  z-index: 9000;
  height: 100%;
}
.right-drawer .mdc-drawer--persistent {
  height: 100%;
}
.right-drawer .mdc-drawer--persistent .mdc-drawer__drawer {
  border-left: 1px solid #e4e4e4;
  left: 0;
  right: 0;
  height: 100%;
  -webkit-transform: translateX(7%);
  transform: translateX(7%);
  -webkit-transform: translateX(20px);
  transform: translateX(calc(20px));
  will-change: transform;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 240px;
  overflow: hidden;
  -ms-touch-action: none;
  touch-action: none;
}
.notification-icon {
  cursor: pointer;
  color: #f7ffff;
  display: flex;
  padding-left: 12px;
}
.notification-icon .mdc-icon {
  font-size: 16px;
}
.notification-icon .unread {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
  background-color: #ffab40;
  font-size: 10px;
  z-index: 100;
  text-align: center;
  position: relative;
  left: -10px;
}
.message-menu {
  top: 48px;
  right: 24px;
  height: 200px;
  width: 300px;
  border-radius: 5px;
}
.message-menu .mark-all {
  text-align: right;
  font-size: 12px;
  cursor: pointer;
}
.message-menu .mdc-menu-item span {
  height: 48px;
  line-height: 48px;
}

.message-menu .mdc-menu-item > span:first-child {
  width: 100%;
}

.message-menu .mdc-icon {
  margin-left: auto;
  padding-left: 16px;
}
footer {
  height: 71px;
}

/** page-cards **/
.page-card .mdc-card__media-content {
  display: flex;
  align-items: center;
}
.page-card .mdc-card-header {
  padding: 0 16px;
}
.page-card .mdc-card-media .mdc-card-header h1,
.page-card .mdc-card-media .mdc-card-header h2 {
  color: #fff;
  font-family: "Roboto Condensed", Roboto, sans-serif;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  font-weight: bold;
}
.page-card .mdc-card-media .mdc-card-header h1 {
  font-size: 3em;
  line-height: 1em;
  padding-top: 0;
}
.page-card .mdc-card-media .mdc-card-header h2 {
  font-size: 1.5em;
  line-height: 1em;
}
.page-card .mdc-card-media.image-cover {
  padding-top: 16px;
  overflow: hidden;
  height: 150px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.page-card .mdc-card-actions.mdc-card__actions {
  height: auto;
  top: -60px;
  position: relative;
  min-height: 40px;
}
.page-card > .mdc-card-text {
  margin-top: -40px;
}
.page-card
  .mdc-card-actions.mdc-card__actions
  .mdc-card__action--icon:not(:disabled) {
  color: white;
}
@media (max-width: 570px) {
  .page-card .mdc-card-media .mdc-card-header h1 {
    font-size: 2em;
  }
  .page-card .mdc-card-media .mdc-card-header h2 {
    font-size: 1em;
  }
  .page-card .mdc-card-media .mdc-card-header h1,
  .page-card .mdc-card-media .mdc-card-header h2 {
    text-shadow: 0px 2.18764px 2.18764px rgba(0, 0, 0, 0.25);
  }
}

/* profile css */
.jobs .avatar-modal .mdc-dialog__surface {
  width:310px;
  min-width:310px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  display: flex;
  flex-flow: row;
  cursor: pointer; /* "hand" cursor */
  width:200px;
}
.inputfile + label .file-select-icon {
  margin-top: -6px;
  margin-right: 12px;
}
.inputfile + label * {
  pointer-events: none;
}

.jobs .mdc-chip.less-prominent {
  opacity:0.6;
}

.jobs .subexp-body {
  border-left:2px solid #CCCCCC;
  margin-left:-16px;
  padding-left:16px;
}
.jobs .about .about-text {
  max-height:8.2em;
  overflow:hidden;
  transition: max-height 0.25s ease-in;
  white-space:pre-wrap;
  overflow-wrap: break-word;
}
.jobs .about.expanded .about-text {
  max-height:2000px;
  height:auto;
  overflow:hidden;
}
.jobs .mdc-list .mdc-list-item {
  flex-flow: row wrap;
  height: auto;
}
.jobs .end-detail {
  white-space: nowrap;
}
.jobs .end-detail .mdc-button {
  width: 28px;
  min-width:28px;
}
.jobs .tiptap-wrap {
  padding:6px;
  width:100%;
  background:whitesmoke;
  margin-top:16px;
}
.jobs .tiptap-wrap .editor{
  margin-top:-12px;
}
.jobs .mdc-text-field-helper-text {
  color:rgba(0, 0, 0, 0.7);
}
.jobs .mdc-list-item.active {
  background-color: #FCFCFC;
}
.jobs .sub-expanded {
  padding-top:16px;
}
.jobs .mdc-textfield.mdc-text-field--upgraded:not(.mdc-text-field--fullwidth):not(.mdc-text-field--box):not(.mdc-text-field--textarea):not(.mdc-text-field--outlined) {
  width:100%;
  border-bottom-color: rgba(0, 0, 0, 0.42);
  background-color: whitesmoke;
  height:56px;
}
.jobs .mdc-textfield label.mdc-floating-label {
  margin-left:6px;
}
.jobs .mdc-textfield input.mdc-text-field__input {
  margin-left:12px;
}
.jobs .subinfo {
  color: var(--mdc-theme-text-secondary-on-light, rgba(0, 0, 0, 0.54));
  margin-top:0;
}
.jobs .sub-label {
  font-size:0.8em;
  margin-top:16;
  margin-bottom:6px;
  color: var(--mdc-theme-text-secondary-on-light, rgba(0, 0, 0, 0.54));
}
.jobs .mdc-card.about {
  min-height: 200px;
}
.jobs .mdc-list--two-line .mdc-list-item {
    min-height: 52px;
    padding-top: 12px;
    padding-bottom: 12px;
}
.jobs .mdc-select--box:not(.mdc-select--disabled).dense {
  background-color:white;
  height:auto;
  min-width:40px;
}
.jobs .mdc-select--box:not(.mdc-select--disabled).dense select {
  height:auto;
  padding:0;
  padding-left:6px;
  height:36px;
}
.jobs .mdc-text-field--fullwidth:not(.mdc-text-field--textarea) {
  height:36px;
}
.jobs .jobs-card-wrapper {
  max-width: 430px;
}
.jobs .align-bottom {
  margin-top:46px;
  height:400px;
}
.jobs .upshift {
  margin-top:-100px;
}
.jobs .upshift--tablet {
  margin-top:-100px;
}
.jobs .upshift--mobile {
  margin-top:0px;
}
.jobs .mobile {
  display:none;
}
.jobs .tablet {
  display:block;
}

@media (max-width: 650px) {
  .jobs .align-bottom {
    margin-top:16px;
  }
  .jobs .upshift--tablet {
    margin-top: -108px;
  }
  .jobs .upshift {
    margin-top:0px;
  }
  .jobs .mobile {
    display:block;
  }
  .jobs .tablet {
    display:none;
  }
}

.jobs .mdc-dialog.mdc-dialog--open {
    z-index: 9999;
    height:auto;
    margin-top: 40px;
}
.jobs .mdc-dialog__body {
  padding-bottom:6px;
}
.jobs .mdc-dialog__footer {
  height:42px;
}

.main-content.jobs {
  padding-bottom: 48px;
  height:auto;
  margin-top: 40px;
}

.jobs .jobs-header {
  height: 25px;
  background-image: none;
  background-size: cover;
  background-repeat: no-repeat;
}

/* App Side Drawer */
.sidebar .mdc-list-item {
  padding: 0;
  border-radius: 0 9px 9px 0;
}
.sidebar .mdc-drawer__content {
  position: fixed;
  width: 240px;
}

.side-menu-heading .mdc-icon {
  display:flex;
}

.side-menu-heading .mdc-list-item__graphic .active {
  display:none;
}

.mdc-ripple-upgraded--foreground-activation .side-menu-heading {
  background-color: #008AD8;
  color: #F7FFFF;
  border-radius: 0 9px 9px 0;
}
.mdc-ripple-upgraded--foreground-activation .side-menu-heading .mdc-list-item__graphic .active {
  display:block;
}
.mdc-ripple-upgraded--foreground-activation .side-menu-heading .mdc-list-item__graphic .nonactive {
  display:none;
}

.mdc-ripple-upgraded--foreground-activation .mdc-list-item__graphic {
  color: white;
}
.mdc-ripple-upgraded--foreground-activation .side-menu-heading .material-icons {
  color: #F7FFFF;
}
.sidebar-scroll {
  padding-top: 0;
  height: calc(100vh - 48px);
  overflow-y: auto;
  overflow-x: hidden;
}
.side-menu-item {
  flex-wrap: wrap;
  height: auto !important;
  color: #333333;
  margin-right: 6px;
  align-items: center;
}
.jobs-card-link {
  text-decoration: none;
  color: #333;
}
.side-menu-item a {
  width:100%;
}

li.mdc-list-item .side-menu-heading {
  width: auto;
}
.side-menu-item .mdc-list{
  padding:0;
  width: 100%;
}
.side-menu-heading {
  font-family: 'Roboto Condensed', Roboto, sans-serif;
  font-Size: 18px;
  line-height: 21px;
  align-items: center;
  display:flex;
  justify-content: flex-start;
  color: #333333;
  padding-left: 6px;
  width:100%;
}
.side-menu-heading div {
    margin-right: 12px;
    overflow: hidden;
}
.sublist1 {
  padding-left:12px!important;
}
.sublist2 {
  padding-left:25px!important;
}

.side-menu-heading a.router-link-active,
.side-menu-heading a.router-link-active .mdc-icon,
.side-menu-heading a.router-link-active > *,
.side-menu-item a.router-link-active,
.side-menu-item a.router-link-active .mdc-icon,
.side-menu-item a.router-link-active > * {
  color:white;
}
.side-menu-heading a.router-link-active,
.side-menu-item a.router-link-active {
  background-color:#008AD8;
  border-radius: 0 9px 9px 0;
}

.side-menu-item a.router-link-active .mdc-list-item__graphic .active {
  display:block;
}
.side-menu-item a.router-link-active .mdc-list-item__graphic .nonactive {
  display:none;
}

.jobs-card-link {
  margin-top:6px;
  width:100%;
}
.mdc-drawer .mdc-drawer__header::before {
  padding-top:0;
}
.mdc-drawer .mdc-drawer__header-content {
  padding:6px;
  flex-flow: row wrap;
  align-items: flex-start;
  position:relative;
}
.avatar {
    width:56px;
    border-radius: 500px;
    -webkit-border-radius: 500px;
    -moz-border-radius: 500px;
}

.sidebar {
  -webkit-transition: width 1s; /* For Safari 3.1 to 6.0 */
  transition: width 0.5s;
}
.sidebar .sidebar-scroll {
  -webkit-transition: width 1s; /* For Safari 3.1 to 6.0 */
  transition: width 0.5s;
}
.sidebar.hidden .sidebar-scroll {
  width:0;
  overflow:hidden;
}
.sidebar.hidden .sidebar-scrol.hiddenl {
  display:none;
}

.mdc-drawer.mdc-drawer--open .mdc-drawer__drawer, .mdc-drawer--permanent.mdc-drawer--permanent {
  background-color:#E9E9E9;
}

.mdc-layout-app .mdc-layout-app--drawer-wrapper > div,
.mdc-layout-app .mdc-layout-app--drawer-wrapper .mdc-drawer {
    height: 100%;
}
.mdc-drawer.sidebar.hidden {
  width: 0px;
  border: none;
}

.mdc-drawer.sidebar .mdc-drawer__drawer{
  max-width: 230px;
}

.bottom-menu-btn {
  position: fixed;
  bottom:0;
  text-align: center;
  padding: 10px 0px 10px 0px;
  z-index:-1;
  height:46px;
  align-items: center;
}

.bottom-icon {
  position:fixed;
  left:0;
  bottom:16px;
}
.bottom-icon::before {
  opacity: 0 !important;
}
.mdc-drawer {
    margin-top: 48px;
}

.job-card-link {
  text-decoration: none;
  color: #333;
  margin-top: 0;
  width: 100%;
}

@media (min-width: 481px) and (max-width: 595px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 8;
  }
}
@media (min-width: 595px) and (max-width: 680px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 4;
  }
}
@media (min-width: 680px) and (max-width:   840px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 4;
  }
}
@media (min-width: 840px) and (max-width:   880px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 6;
  }
}
@media (min-width: 880px) and (max-width:   1140px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 4;
  }
}
@media (min-width: 1240px) {
  .profiles, .jobroles, .companies {
      grid-column-end: span 3;
  }
}

@media all and (max-width: 870px) {
  .mdc-layout-app--drawer-wrapper {
    position: fixed;
    z-index: 999;
    height: calc(100vh);
  }
  main {
    margin-left: 0px;
  }
  .bottom-navbar {
    width: calc(100%);
  }
}
@media all and (max-width: 650px) {
  .mdc-layout-app--drawer-wrapper {
    position: fixed;
    z-index: 999;
    height: calc(100vh);
  }
  main {
    margin-left: 0px;
  }
  .bottom-navbar {
    width: calc(100%);
  }
}

/* Forced Update */
.forced-update {
  display:none
}

.locationmenu i {
  height: 28px !important;
}

.location-wrapper .locationmenu .mdc-line-ripple--active::after,
.location-wrapper .locationmenu .mdc-line-ripple::before {
  border-color: #a9a9a9;
}
.jobs .searchbar-detailed {
  top: 100px;
}
.jobs .VueCarousel-wrapper {
  padding: 0 0 0 20px;
}
.jobs .mdc-select__icon {
  height: 100% !important;
}
</style>
